import { useHomeBanner } from '@/src/api/getData';
import Banner from '@/components/banner';

const ContactUsView = ({ informationData, language = '' }: { informationData: any, language?: string }) => {
    const { data: banner } = useHomeBanner(language);
    let infoData = informationData || {};

    return (
        <main className='theme-latest-update'>
            <Banner banner={banner} category="Contact Us" />
            <section className="contact-details container" id="start">
                <h2>{language == "en" ? 'Welcome to contact us anytime' : '歡迎隨時聯絡我們'}</h2>
                <div className='info-content'>
                    <table>
                        <tbody>
                            <tr>
                                <th>{language == "en" ? 'Tel: ' : '電話 ：'}</th>
                                <td><a href={`tel:${infoData?.Tel || ''}`}>{infoData?.Tel || ''}</a></td>
                            </tr>
                            <tr>
                                <th>{language == "en" ? 'Fax: ' : '傳真 ：'}</th>
                                <td>{infoData?.Fax || ''}</td>
                            </tr>
                            <tr>
                                <th>{language == "en" ? 'Email: ' : '電郵 ：'}</th>
                                <td><a href={`mailto:${infoData?.Email || ''}`}>{infoData?.Email || ''}</a></td>
                            </tr>
                            <tr>
                                <th>{language == "en" ? 'Address: ' : '地址 ：'}</th>
                                <td>{infoData?.Address || ''}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className='map'>
                    <iframe src={infoData?.GoogleMap || ''} loading="lazy" ></iframe>
                </div>
            </section>
        </main>
    );
}

export default ContactUsView;